import L from 'leaflet';
import { MapContainer, Marker, Polygon, TileLayer } from "react-leaflet";

//ASSETS
import pin from '../../../../../../assets/svg/marker.svg';
import pinFertilidade from '../../../../../../../../../../../assets/img/pin-fertilidade-agrupado.svg'

//INTERFACE
interface Props {
    coordenadas: { lat: number, lng: number }[];
    id_map: number;
    width?: number;
    coordendas_pontos: {
        lat: number;
        lng: number;
        ponto: string;
    }[]
}

export const MapaFotos: React.FC<Props> = ({ coordenadas, id_map, coordendas_pontos, width }) => {

    // @ts-ignore
    const polygonFit = new L.Polygon((coordenadas ?? []), {})
    const fitBounds = polygonFit.getBounds()

    return (
        <div style={{ width: width??'100%', height: 300, borderRadius: 10, overflow:'hidden'  }}>
            <MapContainer
                scrollWheelZoom={false}
                dragging={false}
                style={{ width: width??'100%', height: '300px', borderRadius: 10, overflow: 'hidden' }}
                id={`map_fotos_${id_map}`}
                bounds={fitBounds}
                zoomControl={false}
            >
                <TileLayer
                    url='http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}'
                    maxZoom={20}
                    subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
                />
                <Polygon
                    pathOptions={{ color: 'cyan' }}
                    positions={coordenadas}
                />
                {(coordendas_pontos??[]).map((ltdLng, index) => {

                    const iconMarker = L.divIcon({
                    html: `
                        <div style="
                            position: relative;
                            width: 30px;
                            height: 30px;
                        ">
                            <img src="${pin}" style="width: 100%; height: 100%;" />
                            <span style="
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            color: black;
                            font-weight: 600;
                            font-size: 10px;
                            margin-top: -3px;
                            ">
                            ${ltdLng?.ponto}
                            </span>
                        </div>
                    `,
                        className: '', // evita o estilo padrão do leaflet
                        iconSize: [30, 30],
                        iconAnchor: [15, 30], // ajusta para a base do marcador
                    });

                    return <Marker key={Number(ltdLng?.[0])+'_'+index} position={ltdLng} icon={iconMarker} />
                    
                })}
            </MapContainer>
        </div>
    )
}